import { Pipe, PipeTransform } from '@angular/core';

import { DetectionFace } from '../../../people/models/detection.interface';
import { BboxCoordinates } from '../../models/bbox-coordinates';

@Pipe({ name: 'detectionBbox' })
export class DetectionBboxPipe implements PipeTransform {
  transform(detection: DetectionFace): BboxCoordinates {
    const { bbox } = detection;
    return {
      x: bbox.left,
      y: bbox.top,
      w: bbox.right - bbox.left,
      h: bbox.bottom - bbox.top,
    };
  }
}
